var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentCallMute(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.87,
    height: 11.474,
    viewBox: "0 0 10.87 11.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3276e2",
    d: "M9.662 5.435H8.635a3.906 3.906 0 01-.242 1.208l.725.725a3.448 3.448 0 00.544-1.933zM7.246 5.556V1.812a1.812 1.812 0 00-3.623 0v.121zM.785.604L0 1.389l3.623 3.623v.423a1.779 1.779 0 001.812 1.812 1.179 1.179 0 00.423-.06l1.027 1.027a3.582 3.582 0 01-1.389.3 3.119 3.119 0 01-3.2-3.08H1.208A4.2 4.2 0 004.831 9.48v1.994h1.208V9.481a4.1 4.1 0 001.51-.543l2.536 2.536.785-.785z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentCallMute);
export default __webpack_public_path__ + "static/media/recent-call-mute.b27529e58fab05bf4fa10a7ab1381690.svg";
export { ForwardRef as ReactComponent };